import api, { CDN_URL } from '@/api'
import * as types from './mutation-types'

export const configureConnectionFromParams = ({ commit }) => {
  return new Promise((resolve, reject) => {
    const jwt = getParam('jwt')
    const id = getParam('id')
    const unit = getParam('unit')
    const lang = getParam('lang')
    if (jwt && id) {
      if (api.setup(jwt)) {
        commit(types.CONNECTION_CONFIG, { jwt, id, unit, lang })
        resolve()
      } else {
        reject('invalid jwt')
      }
    } else {
      reject('no jwt and videotrack id specified')
    }
  })
}

export const fetchInfo = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.getInfo(state.id)
      .then(response => {
        let data = extractData(response.data.data)
        commit(types.SET_USER, data)
        commit(types.SET_VEHICLE, data)
        commit(types.SET_VIDEO, data)
        commit(types.SET_TRACK, data)
        api.getUser(state.user.id).then(response => {
          const { image } = response.data.data
          if (image) {
            const avatar = `${CDN_URL}/preview/image/${idToPathPart(image)}`
            commit(types.SET_USER_AVATAR, avatar)
          }
        })
        resolve()
      })
      .catch(error => {
        console.log(error)
        reject()
      })
  })
}

export const fetchGraph = ({ commit, state }) => {
  api.getGraph(state.track.url)
    .then(response => {
      commit(types.SET_TRACK_POINTS, { points: response.data })
    })
}

export const percentToTrackIdx = ({ commit, state }, percent) => {
  const idx = Math.round((percent * (state.track.points.length - 1)) / 100)
  commit(types.SET_TRACK_CURRENT_IDX, { idx })
}

function extractData (data) {
  return {
    user: extractUser(data),
    vehicle: extractVehicle(data),
    track: extractTrack(data),
    video: extractVideo(data)
  }
}

function extractUser ({ user_id: id, user_reference: { user_name: name } }) {
  return {
    id,
    name,
    avatar: null
    // avatar: 'https://robohash.org/robo' + id + '?size=40x40&set=set1'
  }
}

function extractVehicle (data) {
  let {
    vehicle_reference: {
      vehicle_name: name,
      brand,
      model,
      avatar
    }
  } = data
  return {
    name,
    brand,
    model,
    avatar: avatar && `${CDN_URL}/preview/image/${idToPathPart(avatar)}`
    // avatar: 'https://robohash.org/robo' + id + '?size=40x40&set=set3'
  }
}

function extractTrack ({ data_name: id, color }) {
  return {
    url: `${CDN_URL}/data/track/${idToPathPart(id)}.graph.json`,
    id: id,
    color: color
  }
}

function extractVideo ({ objects: { video: [id] } }) {
  return {
    url: `${CDN_URL}/data/video/${idToPathPart(id)}_s.mp4`,
    id: id
  }
}

function idToPathPart (id) {
  const parts = id.toString().split('-')
  return parts[1] ? parts[0].substring(0, 2) + '/' + parts[1].substring(0, 2) + '/' + id : id
}

function getParam (name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}



// WEBPACK FOOTER //
// ./src/store/actions.js